import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

interface StyledProps {
  active?: boolean;
  finished?: boolean;
}

export const Container = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5rem 25rem;

  background-color: ${({ active, finished }: StyledProps) =>
    finished ? COLORS.GREEN : active ? COLORS.GREEN_DISABLED : COLORS.WHITE};
  color: ${({ active, finished }: StyledProps) =>
    finished
      ? COLORS.STRICT_WHITE
      : active
      ? COLORS.STRICT_WHITE
      : COLORS.BLACK};

  ${respondTo.midTablet`
    padding: 5rem 10rem;
    font-size: 16rem;
  `}
`;
